module.exports = __webpack_public_path__ + "static/img/p2_09.e48e3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/intro/p2_09.jpg
// module id = YWme
// module chunks = 0